import React, { useContext, useEffect, useState } from "react";

import AddNote from "components/shipment-editor/notes/components/add-note";
import DisplayNotes from "components/notes/components/display-notes";
import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";
import { ShipmentContext } from "components/shipment-editor/contexts";
import { useNotes, useUpdateNotes } from "shared/hooks/api";

export const ShipmentNotes = () => {
    const [notes, setNotes] = useState([]);
    const { viewOnlyShipment } = useContext(ViewOnlyPermissionsContext);
    const { bins, shipmentData } = useContext(ShipmentContext);
    const { data: shipmentNotes, isSuccess } = useNotes({ shipmentKey: shipmentData.key, binTrackingNumber: bins, showAllNotes: true });
    const { mutate: updateNotes } = useUpdateNotes();

    useEffect(() => {
        setNotes(shipmentNotes);
    }, [isSuccess]);

    const addNotes = async (newNotes) => {
        setNotes([...notes, ...newNotes]);
    };

    const updateArchivedNote = ({ results }) => {
        if (!results) {
            return;
        }

        const [result] = results;

        setNotes((allNotes) => {
            return allNotes.map((note) => {
                if (note.noteId === result.note.noteId) {
                    return result.note;
                }

                return note;
            });
        });
    };

    const archiveNote = async (noteId) => {
        updateNotes(
            [
                {
                    noteId,
                    isActive: false,
                },
            ],
            {
                onSuccess: updateArchivedNote,
            }
        );
    };

    return (
        <fieldset>
            <legend>Shipment/Bin Notes applied to specific tasks</legend>
            {!viewOnlyShipment.createNote && <AddNote addNotes={addNotes} bins={bins} shipmentKey={shipmentData.key} />}
            <DisplayNotes notes={notes} archiveNote={archiveNote} displayNoteType={true} allowArchive={!viewOnlyShipment.createNote} />
        </fieldset>
    );
};
